module.exports = __webpack_public_path__ + "static/media/dash-mobile-check.49b2bc34.svg";